export default "__VITE_ASSET__Bh8DOpS6__"